import React from "react";
import { FaTimesCircle } from "react-icons/fa";
import PopUp from "../../components/PopUp";
import { RectBtn } from "../../components/General";
import { useDispatch, useSelector } from "react-redux";
import { selectRoom, selectUserData } from "../../features/store";
import { deleteDevice } from "../../features/slices/deviceSlice";
import { useSnackbar } from "notistack";
import { deleteDevice as deleteDeviceApi } from "../../apis/Device.Api";
import { removeNanoFromRoom } from "../../features/slices/roomSlice";
const DeleteNano = ({ selectedConfig, setSelectedConfig, openDelete, setOpenDelete }) => {
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const userData = useSelector(selectUserData);
    const rooms = useSelector(selectRoom);
    async function confirmDeleteNano() {
        let r = await deleteDeviceApi({
            device_id: selectedConfig.deviceId,
        });
        if (r.data.indicator) {
            enqueueSnackbar(r.data.message, { variant: "success" });
            dispatch(deleteDevice({ deviceId: selectedConfig.deviceId }));
            for (let rid in rooms) {
                if (rooms[rid].nanoId === selectedConfig.deviceId) {
                    dispatch(removeNanoFromRoom({ roomId: rid }));
                }
            }
        } else {
            enqueueSnackbar(r.data.message, { variant: "error" });
            return;
        }

        setOpenDelete(false);
        setSelectedConfig({});
    }
    return (
        <PopUp width={50} height={50} switchOn={openDelete}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Confirmation</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setOpenDelete(false);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="confirmation-wrapper">
                        <h4> Delete Nano? </h4>
                        <p className="description">
                            By confirming, the nano
                            <strong>{" " + selectedConfig.deviceId + " "}</strong>
                            will be deleted. Rooms using this nano will lose its connection. This action cannot be
                            restored.
                        </p>
                        <div className="btn-wrapper">
                            <RectBtn onClick={confirmDeleteNano} warning={true}>
                                <p>Delete</p>
                            </RectBtn>
                        </div>
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default DeleteNano;
